export default function stripParagraph(text: string): string {
  return text.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")
}
